<script setup lang="ts">
import { useTitle } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { watch, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'
import { toast, Toaster } from 'vue-sonner'

import { useUserStore } from './stores/user'

const router = useRouter()
const { t } = useI18n()
const userStore = useUserStore()
const { isAuthenticated } = storeToRefs(userStore)

watch(isAuthenticated, (isAuth, wasAuth) => {
  if (wasAuth && !isAuth) {
    toast.error('请重新登录')
    router.push('/login')
  }
})

const title = useTitle()
watchEffect(() => {
  title.value = `${t('common.adminPlatform')} - ${t('common.openPlatform')}`
})
</script>

<template>
  <div class="min-h-screen bg-white transition-all duration-300 ease-in-out dark:bg-gray-900">
    <Toaster position="top-right" :expand="true" :rich-colors="true" />
    <RouterView v-slot="{ Component }" :key="$route.fullPath">
      <KeepAlive>
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </div>
</template>
